import {
  ACCOUNT_FLAG_MNI,
  ROLE_AM,
  ROLE_ACCOUNT_ADMIN,
  ROLE_CA,
  ROLE_CM,
  ROLE_CU,
  ROLE_INTERNAL_ADMIN,
  ROLE_INTERNAL_SUB_ADMIN,
  ROLE_INTERNAL_USER,
  ROLE_EXTERNAL_SUB_ADMIN,
  ROLE_EXTERNAL_USER,
  EXTERNAL_MNI_ACCOUNT_ID,
  ROLE_EXTERNAL_ADMIN
} from './constant';

const methods = {
  isAccountManager(currentUserRole) {
    return (
      currentUserRole === ROLE_AM ||
      currentUserRole === ROLE_INTERNAL_ADMIN ||
      currentUserRole === ROLE_INTERNAL_SUB_ADMIN ||
      currentUserRole === ROLE_INTERNAL_USER
    );
  },
  isAccountAdmin(currentUserRole) {
    return currentUserRole === ROLE_ACCOUNT_ADMIN;
  },

  isClientAdmin(currentUserRole) {
    return currentUserRole === ROLE_CA;
  },

  isClientManager(currentUserRole) {
    return currentUserRole === ROLE_CM;
  },

  isClientUser(currentUserRole) {
    return currentUserRole === ROLE_CU;
  },

  isInternalAdmin(currentUserRole) {
    return currentUserRole === ROLE_INTERNAL_ADMIN;
  },
  isInternalSubAdmin(currentUserRole) {
    return currentUserRole === ROLE_INTERNAL_SUB_ADMIN;
  },
  isInternalUser(currentUserRole) {
    return currentUserRole === ROLE_INTERNAL_USER;
  },
  isExternalSubAdmin(currentUserRole) {
    return currentUserRole === ROLE_EXTERNAL_SUB_ADMIN;
  },
  isExternalUser(currentUserRole) {
    return currentUserRole === ROLE_EXTERNAL_USER;
  },
  isExternalAdmin(currentUserRole) {
    return currentUserRole === ROLE_EXTERNAL_ADMIN;
  },

  /**
   * Check if user has any of the client-facing roles
   *
   * @param {Object} currentAccountRoles Map of roles the user has in the current account
   * @returns {Boolean}
   */
  isClientFacing(currentUserRole) {
    return (
      this.isClientAdmin(currentUserRole) ||
      this.isClientManager(currentUserRole) ||
      this.isClientUser(currentUserRole)
    );
  },

  // NOT currently used. Left here as an example for future use.
  //
  // /**
  //  * Helper for switching components based on the account/prefix flag.
  //  *
  //  * @param {Account} account object to test
  //  * @param {String} prefix path folder containing custom components. Account
  //  *                        should contain this string in `flags`.
  //  * @param {String} component base filename
  //  * @returns {Promise} dynamic import loader
  //  */
  // switchComponent(account, prefix, component) {
  //   let path = '';
  //   if (account && account.hasFlag(prefix)) {
  //     // use prefix if contained in account flags
  //     path = `${prefix}/`;
  //   }
  //   return () => import(`./components/partials/${path}${component}.vue`);
  // },

  /**
   * Test whether the given account is MNI.
   *
   * @param {Account} account object to test
   * @returns {Boolean} true if an MNI account
   */
  isMniAccount(account) {
    if (account) {
      return account.hasFlag(ACCOUNT_FLAG_MNI);
    }
    return false;
  },


  /**
   * Test whether the give account is MNI external account.
   * @param {Account} account object to test
   * @returns {Boolean} true if an MNI External account
   */
  isExternalMni(account) {
    if (account) {
      return account.id === EXTERNAL_MNI_ACCOUNT_ID;
    }
    return false;
  },


  isAdmin(currentUser) {
    if (currentUser && currentUser.role) {
      return currentUser.role.name === ROLE_INTERNAL_ADMIN;
    }
    return false;
  },
};

export default {
  ...methods,
};
